// Same adapter, but for routes whose component needs static props

export function lazyRoute(load, name = 'default') {
  return async () => ({ Component: (await load())[name] });
}

export function lazyRouteWithProps(load, name, props) {
  return async () => {
    const Component = (await load())[name];
    const RouteComponent = () => <Component {...props} />;
    RouteComponent.displayName = `LazyRoute(${Component.displayName ?? Component.name ?? name})`;

    return { Component: RouteComponent };
  };
}
